export const BATTERY_NAME_FIELD_NAME = 'name';

export const SERIAL_NUMBER_FIELD_NAME = 'serialNumber';

export const TEST_ID = 'batteryFormFields';
